"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchResultPlayerStatus = void 0;
var MatchResultPlayerStatus;
(function (MatchResultPlayerStatus) {
    MatchResultPlayerStatus["Win"] = "win";
    MatchResultPlayerStatus["Lose"] = "lose";
    MatchResultPlayerStatus["Forfeit"] = "forfeit";
    MatchResultPlayerStatus["Tied"] = "tied";
})(MatchResultPlayerStatus = exports.MatchResultPlayerStatus || (exports.MatchResultPlayerStatus = {}));
//# sourceMappingURL=match-result-player-status.js.map